import { chipClasses } from "@mui/material";
import { ReactNode, forwardRef } from "react";

import AppChip, { AppChipProps } from "./AppChip";

export interface AppIconChipProps extends Omit<AppChipProps, "icon" | "label"> {
  icon: ReactNode;
}

/** Chips that contains icon only.  */
export default forwardRef<HTMLDivElement, AppIconChipProps>(function AppIconChip(
  { icon, size, shape = "square", sx, ...otherProps }: AppIconChipProps,
  ref,
) {
  return (
    <AppChip
      ref={ref}
      sx={{
        height: 32,
        width: "unset",
        aspectRatio: "1 / 1",
        p: 0,
        fontSize: "inherit",

        [`& .${chipClasses.label}`]: {
          display: "inline-flex",
          p: 0,
        },

        ...(size === "extraSmall" && { height: 20, fontSize: "small" }),
        ...(size === "small" && { height: 24, fontSize: "small" }),
        ...(size === "medium" && { height: 32, fontSize: "medium" }),
        ...(size === "large" && { height: 40, fontSize: "medium" }),

        ...sx,
      }}
      size={size}
      label={icon}
      shape={shape}
      {...otherProps}
    />
  );
});
